import { render, staticRenderFns } from "./ModuleInstaller.vue?vue&type=template&id=566308ac"
import script from "./ModuleInstaller.vue?vue&type=script&lang=js"
export * from "./ModuleInstaller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566308ac')) {
      api.createRecord('566308ac', component.options)
    } else {
      api.reload('566308ac', component.options)
    }
    module.hot.accept("./ModuleInstaller.vue?vue&type=template&id=566308ac", function () {
      api.rerender('566308ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/modulos/series-documentales/ModuleInstaller.vue"
export default component.exports